import { Avatar } from 'evergreen-ui';
import { styled } from 'linaria/react';
import React, { FC, useEffect } from 'react';
import { useStore } from 'effector-react';

import { Group, MemberRole } from 'src/domain/group';
import { Pagination } from 'src/ui/molecules/pagination';
import { fetchMembersFx, group$, members$ } from 'src/store/group.store';

const MemberItem = styled.div`
	display: flex;
	align-items: center;
	padding: 10px 0;
	border-bottom: 1px solid var(--gray100);
`;
const MemberName = styled.div`
	font-weight: 600;
	margin-left: 8px;
	margin-right: 8px;
`;
const Badge = styled.div`
	display: inline-block;
	padding: 3px 6px;
	border-radius: 10px;
	font-size: 13px;
	background: var(--blue500);
	color: white;
`;

export const GroupDetails = () => {
	const members = useStore(members$);
	const group = useStore(group$);

	useEffect(() => {
		fetchMembersFx({ page: 0 });
	}, [group]);

	return (
		<>
			{members && members.data.map(item => {
				const fullName = [
					item.user.details.first_name,
					item.user.details.last_name,
				].join(' ');

				return (
					<MemberItem key={item.id}>
						<Avatar size={40} name={fullName} src={item.user.details.avatar || undefined}/>
						<MemberName>
							{fullName}
						</MemberName>
						{item.role === MemberRole.owner && (
							<Badge>Owner</Badge>
						)}
					</MemberItem>
				);
			})}
			{members && members.data.length > 0 ? (
				<Pagination
					page={members.meta.page}
					total={members.meta.total}
					onPaginated={(page) => {
						fetchMembersFx({ page });
					}}
				/>
			) : (
				<Pagination
					page={0}
					total={1}
					onPaginated={() => {}}
				/>
			)}
		</>
	);
};
